import React from 'react';
import { Button, Tooltip, ButtonProps } from 'antd';
import { useHoliday } from 'store/HolidayContext';
import { useTranslation } from 'react-i18next';

interface HolidayButtonProps extends ButtonProps {
	tooltip?: string;
	name?: string;
}

const ActionButton: React.FC<HolidayButtonProps> = ({ children, tooltip, disabled, ...props }) => {
	const { isTodayHoliday } = useHoliday();
	const { t } = useTranslation();

	// Merge existing tooltip with holiday message
	const finalTooltip = isTodayHoliday ? t<string>('holidayDay') : tooltip ? tooltip : '';

	return (
		<Tooltip title={finalTooltip}>
			<span>
				<Button {...props} disabled={isTodayHoliday || disabled}>
					{children}
				</Button>
			</span>
		</Tooltip>
	);
};

export default ActionButton;
